import { gsap } from "gsap"
import { find, findAll } from "utils/dom"

export default function initSiteHeader() {
	const header = find("header.site-header")
	if (!header) return

	const mobile = window.matchMedia("(max-width: 1200px)").matches
	const logo = find(".logo", header)
	const links = findAll("nav ul li", header)
	const ticket = find(".btn-header-ticket", header)
	const menuBtn = find(".open-menu", header)

	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

	if (reduceMotion) {
		gsap.set([header, logo, ...links, ticket, menuBtn].filter(Boolean), { clearProps: "all" })
		header.classList.add("is-ready")
	} else {
		gsap.set(header, { yPercent: -100 })
		gsap.set(logo, { opacity: 0, y: -12 })

		if (mobile) {
			// nav + CTA somem no CSS; só logo + hamburger
			gsap.set([...links, ticket].filter(Boolean), { clearProps: "all", opacity: 1 })
			if (menuBtn) gsap.set(menuBtn, { opacity: 0, scale: 0.85 })
		} else {
			gsap.set(links, { opacity: 0, y: -10 })
			if (ticket) gsap.set(ticket, { opacity: 0, y: -10, scale: 0.94 })
			if (menuBtn) gsap.set(menuBtn, { clearProps: "all", opacity: 1 })
		}

		const tl = gsap.timeline({
			defaults: { ease: "power2.out" },
			onComplete: () => header.classList.add("is-ready"),
		})

		tl.to(header, { yPercent: 0, duration: mobile ? 0.4 : 0.55, ease: "power3.out" }, 0)

		if (logo) tl.to(logo, { opacity: 1, y: 0, duration: 0.4 }, 0.22)

		if (mobile) {
			if (menuBtn) tl.to(menuBtn, { opacity: 1, scale: 1, duration: 0.32 }, 0.32)
		} else {
			if (links.length) {
				tl.to(links, { opacity: 1, y: 0, duration: 0.35, stagger: 0.06 }, 0.4)
			}
			if (ticket) {
				tl.to(
					ticket,
					{ opacity: 1, y: 0, scale: 1, duration: 0.4, ease: "back.out(1.4)" },
					0.55,
				)
			}
		}
	}

	const onScroll = () => {
		header.classList.toggle("is-scrolled", window.scrollY > 12)
	}
	onScroll()
	window.addEventListener("scroll", onScroll, { passive: true })
}
